import React, { useState, useEffect, useContext, useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import URLstateContext from "../../provider/CommonContext";
import "./Sitemap.css";
import { useNavigate } from "react-router-dom";
import { Apiurl } from "../Configuration/configuration";
import CallTrackApi from "../Activity_Track/CallTrackApi";

function Sitemap() {

    const [show, setShow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    const [dataWatch, setDataWatch] = useState([]);

    const [data, setData] = useState(false);
    const { BaseLiveURL } = useContext(URLstateContext);
    const [nodatafound, setnodatafound] = useState(false);

    const [loadingshow, setloadingshow] = useState(false);
    let getDataWatch, getDataaa, getDataList, getDataPer;
    let navigate = useNavigate();
    let PageSize = 5;

    useEffect(() => {
        postData(`${Apiurl}/api/Login/SitemapContent`)
            .then((data) => {
                if (data.data != null && data.data.length > 0) { setnodatafound(false); setData(data.data); }
                else { setData(null); setnodatafound(true); }
            });
    }, []);

    async function postData(url = '', data = {}) {

        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }
    
    CallTrackApi("Sitemap",window.location.href);

    return (
        <>
            <Col>
                <h2 class="sitehead text-center">Sitemap</h2>
            </Col>

            <section className="sitemap-bg">

                <Container>
                    <Row>
                        {(data === null) ? <h5 className="errormsgSGB">No Data Found !!!</h5> : ''}
                        {(data) && data.map(
                            ({ heading, sitelink }) => (
                                <>
                                    <Col lg={4} md={8} sm={6} xs={12} className="sitemap-inner">
                                        <ul>
                                            <li><a href={sitelink}>{heading}</a></li>
                                        </ul>
                                    </Col>
                                </>

                            )
                        )}
                    </Row>
                </Container>
            </section>
         
        </>
    );
}
export default Sitemap;